import { MAX_VOLUME, MIN_VOLUME, REPLAYER_SPEED_OPTIONS } from '../constants'
import { ValidatedRecording } from '../ertUtils'
import { isErtDebugModeEnabled } from '../rrweb/rrwebUtils'

export const normalizeVolume = (value: number): number => {
  return Math.round(Math.max(MIN_VOLUME, Math.min(MAX_VOLUME, value)))
}

export const normalizePlaybackSpeed = (speed: number): number => {
  return REPLAYER_SPEED_OPTIONS.includes(speed) ? speed : 1
}

export const getRecordingError = (recordings: ValidatedRecording[] | undefined): string | undefined => {
  const recordingsWithErrors = recordings?.filter(recording => recording.error)
  return recordingsWithErrors?.length
    ? isErtDebugModeEnabled()
      ? recordingsWithErrors[0].errorDescription
      : recordingsWithErrors[0].error
    : undefined
}
